import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { AcademicYearResponse } from "../../models/dtos"; 

export const academicYearsApi = createApi({
  reducerPath: 'academicYearsApi',
  baseQuery: baseAuthQuery('AcademicYears'),
  tagTypes: ['AcademicYear'],
  endpoints: (builder) => ({
    getAcademicYears: builder.query<ApiResponse<AcademicYearResponse[]>, void>({
      query: () => "",
      providesTags: ['AcademicYear'],
    }),
    getAcademicYearById: builder.query<ApiResponse<AcademicYearResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['AcademicYear'],
    }),
    updateAcademicYear: builder.mutation<ApiResponse<AcademicYearResponse>, Partial<AcademicYearResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['AcademicYear'],
    }),
    deleteAcademicYear: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['AcademicYear'],
    }),
    getCurrentAcademicYearId: builder.query<ApiResponse<number>, void>({
      query: () => "current",
      providesTags: ['AcademicYear'],
    }),
  }),
});
